import { Component, Input } from '@angular/core';
import { ExpansionPanel } from '@app/eds/constants';

@Component({
  selector: 'app-expansion-panel',
  templateUrl: './expansion-panel.component.html',
  styleUrls: ['./expansion-panel.component.scss']
})
export class ExpansionPanelComponent {
  // This provides the icon name for the expanded panel
  @Input() panelOpenStateIcon!: string;

  // This provides the icon name for the collapsed panel
  @Input() panelCloseStateIcon!: string;

  // This provides info whether to show the panel icon or not
  @Input() panelToggleIcon = true;

  // This provides panel style like height
  @Input() panelHeaderHeight!: string;

  // A property contains the style class name for mat-expansion-anel
  @Input() panelStyleClasses!: string | string[];

  // A proeprty contains the style class name for header only
  @Input() headerStyleClasses!: string | string[];

  // description class style in the header
  @Input() public headerDescriptionClasses!: string | string[];

  // Description Style in header
  @Input() public headerDescriptionStyle!: { [key: string]: string };

  // This provides info on whether the panel is expanded or not
  panelOpenState!: boolean;

  /**
   * This method will help to set panelOpenState value.
   * @param {boolean} state
   */
  setPanelOpenState = (state: boolean) => {
    this.panelOpenState = state;
  };

  /**
   * This method will help to return the icon name when the panel is expaned.
   *
   * @returns {string}
   */
  getPanelOpenStateIcon = () =>
    this.panelOpenStateIcon ? this.panelOpenStateIcon : ExpansionPanel.ARROW_DOWN;

  /**
   * This method will help to return the icon name when the panel is collapsed.
   *
   * @returns {string}
   */
  getPanelCloseStateIcon = () =>
    this.panelCloseStateIcon ? this.panelCloseStateIcon : ExpansionPanel.ARROW_UP;

  /**
   * This method will help to return custom panel header style.
   *
   * @returns {string}
   */
  getPanelHeaderStyle = () => (this.panelHeaderHeight ? this.panelHeaderHeight : '');
}
